import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M4.25 6.5C4.25 5.25736 5.25736 4.25 6.5 4.25H12C12.4142 4.25 12.75 3.91421 12.75 3.5C12.75 3.08579 12.4142 2.75 12 2.75H6.5C4.42893 2.75 2.75 4.42893 2.75 6.5V17.5C2.75 19.5711 4.42893 21.25 6.5 21.25H17.5C19.5711 21.25 21.25 19.5711 21.25 17.5V12C21.25 11.5858 20.9142 11.25 20.5 11.25C20.0858 11.25 19.75 11.5858 19.75 12V17.5C19.75 18.7426 18.7426 19.75 17.5 19.75H6.5C5.25736 19.75 4.25 18.7426 4.25 17.5V6.5ZM19.2374 3.67678C18.554 2.99336 17.446 2.99336 16.7626 3.67678L14.9697 5.46967L8.96967 11.4697C8.82902 11.6103 8.75 11.8011 8.75 12V14.5C8.75 14.9142 9.08579 15.25 9.5 15.25H12C12.1989 15.25 12.3897 15.171 12.5303 15.0303L18.5303 9.03033L20.3232 7.23744C21.0066 6.55402 21.0066 5.44598 20.3232 4.76256L19.2374 3.67678ZM17.8232 4.73744C17.9209 4.63981 18.0791 4.63981 18.1768 4.73744L19.2626 5.82322C19.3602 5.92086 19.3602 6.07915 19.2626 6.17678L18 7.43934L16.5607 6L17.8232 4.73744ZM15.5 7.06066L16.9393 8.5L11.6893 13.75H10.25V12.3107L15.5 7.06066Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
